<template>
  <div class="img-list-look">
    <ul :class="{ isFour, isOne }">
      <li
        v-for="(item, index) in imgList"
        :key="index"
        @click="showImage(imgList, index)"
      >
        <div>
          <img :src="item" alt="" />
        </div>
      </li>
    </ul>
    <imagePreview :items="previewImages"></imagePreview>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import imagePreview from '@/components/common/viewImageNew'
export default {
  components: { imagePreview },
  props: {
    imgList: {
      type: [Array],
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapState(['previewImages']),
    isFour() {
      return this.imgList.length == 4
    },
    isOne() {
      return this.imgList.length == 1
    }
  },
  methods: {
    showImage(images, index) {
      const query = this.$route.query
      this.$store.commit('setPreviewImages', images)
      this.$router.push({ query: { ...query, preview: true, index } })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.img-list-look {
  ul {
    display: flex;
    flex-wrap: wrap;
    margin: rem(-6px);
    &.isFour {
      > li:nth-child(even) {
        margin-right: 10%;
      }
    }
    &.isOne {
      > li > div {
        width: rem(446px);
        height: rem(446px);
      }
    }
    > li {
      padding: rem(6px);
      > div {
        width: rem(210px);
        height: rem(210px);
        border-radius: rem(8px);
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
